(() => {
  if (!window.productDataSelector) return;

  const productScriptTag = document.querySelector(window.productDataSelector);
  if (!productScriptTag) return;

  const parsedData = JSON.parse(productScriptTag.innerHTML);
  const items = parsedData.items ?? [parsedData];

  /* Push to dataLayer */
  window.dataLayer = window.dataLayer || [];
  dataLayer.push({ ecommerce: null });
  window.dataLayer.push({
    event: 'view_item',
    ecommerce: {
      items,
    },
  });

  console.log('%cEvent: view_item', 'color: #FF9100');
  console.log(window.dataLayer);
})();